import { Currency } from '@prisma/client';

export const affiliateQuotesKeys = {
  FETCH_AFFILIATE_SERVICES_DESCRIPTION: (
    affiliateFirmId: string,
    serviceIds: string[]
  ) => [
    'affiliate-quotes',
    'services-descriptions',
    affiliateFirmId,
    serviceIds,
  ],
  FETCH_AFFILIATE_QUOTES: 'FETCH_AFFILIATE_QUOTES',
  FETCH_AFFILIATE_QUOTE: (quoteId: string) => [
    'affiliate-quotes',
    'quote',
    quoteId,
  ],
  FETCH_AFFILIATE_SERVICES: (affiliateFirmId: string, currency: Currency) => [
    'affiliate-quotes',
    'services',
    affiliateFirmId,
    currency,
  ],
};
